export const initializePendo = user => {
  if (user !== null && user.userId !== null) {
    window.pendo.initialize({
      visitor: {
        id: user.userId,
        email: user.username,
        role: user.role,
        environment: window.location.host
      },
      account: {
        id: user.clientId,
        name: user.clientName,
        environment: window.location.host
      },
      excludeAllText: true
    });

    try {
      window.pendo.validateEnvironment();
    } catch (error) {
      console.dir(error);
    }
  }
};
